import React, { useEffect, useState, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BreadCrumb from "Common/BreadCrumb";
import callApi from "Common/utils/apiCaller";
import Flatpickr from "react-flatpickr";
import CustomInput from "Common/Components/InputFields/CustomInput";
import CustomSelect from "Common/Components/InputFields/CustomSelect";
import FileUpload from "Common/Components/InputFields/FileUploadBtn";
import IndexCurrency from "../../constants/IndexCurrency.json";
import { showNotification } from "Common/utils/Notification";
import { indexDownload } from "Common/utils/imageUploader";
import indexValue from "../../constants/indexValue.json";
import constituent from "../../constants/constituent.json";
import checkTypeIndex from "../../constants/checkTypeIndex.json";
import { INDEX_LIST_ROUTE, INDEX_ADD_ROUTE } from "constants/routeEnum";
import constituentType from "../../constants/constituentType.json";
import ReactSelect from "Common/Components/ReactSelect/ReactSelect";
import _ from "lodash";
import CustomDateInput from "Common/Components/InputFields/CustomDateInput";
import CustomTextArea from "Common/Components/InputFields/CustomTextArea";
import Drawer from "Common/Components/Drawer";
import { X } from "lucide-react";
import { getImageUrl } from "Common/utils/ImageDomain";
import AsyncSelect from "react-select/async";
import ImageView from "Common/Components/ImageView/ImageView";
import SearchDropdown from "Common/Components/searchComponent/SearchComponent";
import { TailSpin } from "react-loader-spinner";
import LoaderComponent from "Common/Components/Loader/Loader";
import { indexmethadologyUploader } from "Common/utils/imageUploader";
import { useNavigate } from "react-router-dom";
import MethodologyFileUploader from "./MethodologyFileUploader";
import moment from "moment";

const LinearKeys = [
  "page_title",
  "meta_keyword",
  "meta_description",
  "url",
  "canonical_url",
  "name",
  "pt_name",
  "hb_name",
  "jp_name",
  "kr_name",
  "constituents_update",
  "constituents_tagline",
  "pt_constituents_tagline",
  "kr_constituents_tagline",
  "jp_constituents_tagline",
  "hb_constituents_tagline",
  "url",
  "description",
  "pt_description",
  "hb_description",
  "jp_description",
  "kr_description",
  "factsheet_type",
  "factsheet_media_url",
  "factsheet_media_id",
  "methodology_media_url",
  "methodology_media_id",
  "portuguese_media_url",
  "portuguese_media_id",
  "korean_media_url",
  "korean_media_id",
  "hebrew_media_url",
  "hebrew_media_id",
  "japanese_media_url",
  "japanese_media_id",
  "languages",
  "dividend_yield",
  "pr_code",
  "tr_code",
  "ntr_code",
  "constituents_keys_visible",
];

const getLinearKeys = (formData) => {
  return LinearKeys.filter((key) => {
    if (key === "pr_code" && !formData?.return_type?.includes("PR"))
      return false;
    if (key === "tr_code" && !formData?.return_type?.includes("TR"))
      return false;
    if (key === "ntr_code" && !formData?.return_type?.includes("NTR"))
      return false;
    return true;
  });
};

const KeysWithDate = ["base_date"];

const LinearBooleanKeys = [
  "is_factsheet_visible",
  "is_methodology_visible",
  "is_characteristics_visible",
  "is_risk_return_statisics_visible",
  "is_charts_visible",
  "is_download_index_values_visible",
  "is_constituent_visible",
  "is_pr_value_visible",
  "is_tr_value_visible",
  "is_ntr_value_visible",
];

const LineearKeysWithOptions = [
  "factsheet_type",
  "currency",
  "category",
  "sub_category",
  "constituent_type",
  "currency",
  "return_type",
  "calculator_type",
  "benchmark_pr_code",
  "benchmark_tr_code",
  "benchmark_ntr_code",
];

const ManageIndices = () => {
  const navigate = useNavigate();
  const [docView, setDocView] = useState<any>(undefined);
  const [documentView, setDocumentView] = useState<any>();
  const [categoryOption, setCategoryOption] = useState<any>();
  const [subCategoryOption, setSubCategoryOption] = useState<any>();
  const [showMode, setShowMode] = useState<any>(false);
  const defaultToggle = () => setShowMode(!showMode);
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [errors, setErrors] = useState<any>({});
  const [loader, setLoader] = useState<any>(false);
  const [checkedType, setCheckedType] = useState<any>([]);
  const [constituentData, setConstituentData] = useState<any>([]);
  const [categoryList, setCategoryList] = useState<any>([]);
  const [subCategoryList, setSubCategoryList] = useState<any>([]);
  const [benchmarkList, setBenchmarkList] = useState<any>([]);
  const [isDocument, setIsDocument] = useState<any>(false);
  const [languageList, setLanguageList] = useState<any>([]);
  const [factsheetTypeList, setFactsheetTypeList] = useState<any>([]);
  const [returnTypeList, setReturnTypeList] = useState<any>([]);
  const [selectedFiles, setSelectedFiles] = useState<any>();
  const [constituentTypeList, setConstituentTypeList] = useState<any>([]);
  const [imageData, setImageData] = useState<any>();
  const [selectedFile, setSelectedFile] = useState<any>();
  const [imageLink, setImageLink] = useState<any>("");

  const [selectedValues, setSelectedValues] = useState<any>([]);

  const [indexVersions, setIndexVersions] = useState<any>({
    PR: {
      index_code: "",
      index_id: "",
      index_name: "",
      benchmark_code: "",
      benchmark_id: "",
      benchmark_name: "",
      base_date: new Date().toISOString(),
    },
    TR: {
      index_code: "",
      index_id: "",
      index_name: "",
      benchmark_code: "",
      benchmark_id: "",
      benchmark_name: "",
      base_date: new Date().toISOString(),
    },
    NTR: {
      index_code: "",
      index_id: "",
      index_name: "",
      benchmark_code: "",
      benchmark_id: "",
      benchmark_name: "",
      base_date: new Date().toISOString(),
    },
  });

  const [constituentVisibilityList, setConstituentVisibilityList] =
    useState<any>([]);
  const [isLoading, setIsLoading] = useState<any>(false);

  const initializeFormData = () => {
    const formData = {};
    LinearKeys.forEach((key) => {
      formData[key] = "";
    });
    LinearBooleanKeys.forEach((key) => {
      formData[key] = false;
    });
    LineearKeysWithOptions.forEach((key) => {
      formData[key] = "";
    });
    KeysWithDate.forEach((key) => {
      formData[key] = new Date();
    });
    return formData;
  };
  const initialFormData = initializeFormData();

  const [formData, setFormData] = useState<any>(initialFormData);

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "document") {
        setImageLink(imageData);
        setErrors((prev) => ({
          ...prev,
          ["factsheet_media_url"]: "",
        }));
      } else {
        showNotification("Please select pdf", "error");
      }
    }
  }, [imageData]);

  useEffect(() => {
    const fetchDataByCode = async (code: string) => {
      const res = await callApi(`v1/content/code/${code}`, "get", {});
      if (res.status === "Success") {
        return res.data.content?.params || [];
      }
      return [];
    };
    const fetchAllData = async () => {
      let results = await Promise.all([
        fetchDataByCode("factsheet-type"),
        fetchDataByCode("return-type"),
        fetchDataByCode("constituent-type"),
        fetchDataByCode("constituent-visibility"),
        fetchDataByCode("language-type"),
      ]);
      if (results.length > 0) {
        setFactsheetTypeList(results[0]);
        setReturnTypeList(results[1]);
        setConstituentTypeList(results[2]);
        setConstituentVisibilityList(results[3]);
        setLanguageList(results[4]);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    const fetchCategory = async () => {
      let filters: { [index: string]: any } = {};

      const res = await callApi("v1/category/list", "post", {
        pageNum: 1,
        pageSize: 100,
        filters,
      });
      if (res?.status === "Success") {
        setCategoryList(
          res.data.categoryList.map((item) => ({
            label: item?.name,
            value: item?.name,
          }))
        );
      }
    };

    fetchCategory();
  }, []);

  useEffect(() => {
    const fetchSubCategory = async (code: string) => {
      let filters: { [index: string]: any } = {
        category_slug: _.kebabCase(code),
      };

      const res = await callApi("v1/subcategory/list", "post", {
        pageNum: 1,
        pageSize: 100,
        filters,
      });
      if (res?.status === "Success") {
        setSubCategoryList(
          res.data.subcategoryList.map((item) => ({
            label: item?.name,
            value: item?.slug,
          }))
        );
      }
    };

    if (formData?.category || categoryOption) {
      fetchSubCategory(formData?.category || categoryOption);
    }
  }, [formData, categoryOption]);

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    if (name === "name") {
      setFormData((prev) => ({
        ...prev,
        ["url"]: _.deburr(value).toLowerCase().replace(/ /g, "-"),
      }));
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleVersionChange = (
    returnType: string,
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;

    setIndexVersions((prev) => ({
      ...prev,
      [returnType]: {
        ...prev[returnType],
        [name]: value,
      },
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSelectChange = (
    name: string,
    selectedValue: string | string[]
  ) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedValue === "other" ? "" : selectedValue,
    }));

    if (name === "category") {
      setCategoryOption(selectedValue === "other" ? "other" : "");
    }

    if (name === "sub_category") {
      setSubCategoryOption(selectedValue === "other" ? "other" : "");
    }
    if (name === "factsheet_type") {
      setFormData((prev) => ({
        ...prev,
        ["is_factsheet_visible"]: true,
      }));
    }

    if (selectedValue?.[0] === "N") {
      setFormData((prev) => ({
        ...prev,
        ["is_constituent_visible"]: false,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        ["is_constituent_visible"]: true,
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleMultiSelectChange = (name: string, selectedValues: string[]) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedValues,
    }));
    setSelectedValues(selectedValues);
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleDownloadConstituentSample = async () => {
    let arr = [];

    const rows = [["constituent", "isin", "weight", "cdate", "mic"]];

    let csvContent = "";

    constituent?.forEach((e) => {
      rows.push([e.constituent, e.isin, e.weight, e.cdate, e.mic]);
    });

    rows.forEach((rowArray) => {
      let row = rowArray.join(",");
      csvContent += row + "\n";
    });
    let contentType = "text/csv";
    let filename = `${`contituent_sample`}.csv`;

    if (!contentType) contentType = "application/octet-stream";
    var a = document.createElement("a");
    var blob = new Blob([csvContent], { type: contentType });
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    a.click();
  };

  const handleBenchmarkChange = (return_type, name, value) => {
    setIndexVersions((prev) => ({
      ...prev,
      [return_type]: {
        ...prev[return_type],
        [name]: value ? value.value : null,
      },
    }));
  };

  const downloadConstituentSample = () => {
    try {
      handleDownloadConstituentSample();
      toast.success("File downloaded 👌", { hideProgressBar: true });
    } catch (error) {
      toast.error("Failed to download 🤯", { hideProgressBar: true });
    }
  };

  const downloadValueSample = () => {
    try {
      handleDownloadValueSample();
      toast.success("File downloaded 👌", { hideProgressBar: true });
    } catch (error) {
      toast.error("Failed to download 🤯", { hideProgressBar: true });
    }
  };

  const handleFormData = (e) => {
    const { name, value } = e.target;
    let arr = [];
    if (!checkedType.some((existingItem) => existingItem === name)) {
      arr.push(name);
    }
    setCheckedType((prev) => {
      if (prev.some((lead) => lead === name)) {
        return prev.filter((item) => !(item === name));
      }

      return [...prev, ...arr];
    });
  };

  const handleConstituentData = (e) => {
    const { name, value } = e.target;

    let arr = [];
    if (!constituentData.some((existingItem) => existingItem === name)) {
      arr.push(name);
    }
    setConstituentData((prev) => {
      if (prev.some((lead) => lead === name)) {
        return prev.filter((item) => !(item === name));
      }

      return [...prev, ...arr];
    });
  };

  useEffect(() => {
    if (checkedType?.length !== 0) {
      for (let item of checkedType) {
        setFormData((prev) => ({
          ...prev,
          [item]: true,
        }));
      }

      for (let item of checkTypeIndex) {
        if (!checkedType.some((items) => items === item.label)) {
          setFormData((prev) => ({
            ...prev,
            [item.label]: false,
          }));
        }
      }
    } else {
      for (let item of checkTypeIndex) {
        setFormData((prev) => ({
          ...prev,
          [item.label]: false,
        }));
      }
    }
  }, [checkedType]);

  useEffect(() => {
    if (constituentData.length !== 0) {
      setFormData((prev) => ({
        ...prev,
        ["constituents_keys_visible"]: constituentData,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        ["constituents_keys_visible"]: [],
      }));
    }
  }, [constituentData]);


  useEffect(() => {
    // Sync PR, TR, and NTR base dates when main base_date changes
    if (formData.base_date) {
      setIndexVersions((prev) => ({
        ...prev,
        PR: {
          ...prev.PR,
          base_date: formData.base_date,
        },
        TR: {
          ...prev.TR,
          base_date: formData.base_date,
        },
        NTR: {
          ...prev.NTR,
          base_date: formData.base_date,
        },
      }));
    }
  }, [formData.base_date]);

  const handleDownloadValueSample = async () => {
    let arr = [];

    const rows = [["date", "pr_value", "tr_value", "ntr_value"]];

    let csvContent = "";

    indexValue?.forEach((e) => {
      rows.push([e.date, e.pr_value, e.tr_value, e.ntr_value]);
    });

    rows.forEach((rowArray) => {
      let row = rowArray.join(",");
      csvContent += row + "\n";
    });
    let contentType = "text/csv";
    let filename = `${`value_sample`}.csv`;

    if (!contentType) contentType = "application/octet-stream";
    var a = document.createElement("a");
    var blob = new Blob([csvContent], { type: contentType });
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    a.click();
  };

  const handleAcceptedFiles = async (file: any) => {
    if (file?.type?.split("/")[1] === "pdf") {
      setIsDocument(true);
      const res = await indexmethadologyUploader(file, "");
      setIsDocument(false);
      if (res.status === "Success") {
        showNotification("Uploaded successfully", "success");
        setSelectedFile(res.data.fileData);
      } else {
        setIsDocument(false);
      }
    } else {
      showNotification("File type should be pdf", "error");
    }
  };

  const handleAcceptedFile = async (file: any) => {
    if (file?.type?.split("/")[1] === "pdf") {
      setIsLoading(true);
      const res = await indexmethadologyUploader(file, "");
      setIsLoading(false);
      if (res.status === "Success") {
        showNotification("Uploaded successfully", "success");
        setSelectedFiles(res.data.fileData);
      } else {
        setIsLoading(false);
      }
    } else {
      showNotification("File type should be pdf", "error");
    }
  };

  const validateForm = () => {
    let newErrors: { [index: string]: any } = {};

    if (!formData.base_date) newErrors.base_date = "Base Date is required.";

    if (
      !formData.constituents_update ||
      (typeof formData.constituents_update === "string" && formData.constituents_update.trim() === "")
    )
      newErrors.constituents_update = "Constituents Update is required.";


    if (!formData.name || formData.name.trim() === "")
      newErrors.name = "Name is required.";

    if (
      formData.languages?.includes("hebrew") &&
      (!formData.hb_name ||
        (typeof formData.hb_name === "string" && formData.hb_name.trim() === ""))
    ) {
      newErrors.hb_name = "Hebrew Name is required.";
    }

    if (
      formData.languages?.includes("japanese") &&
      (!formData.jp_name ||
        (typeof formData.jp_name === "string" && formData.jp_name.trim() === ""))
    ) {
      newErrors.jp_name = "Japnese Name is required.";
    }

    if (
      formData.languages?.includes("portuguese") &&
      (!formData.pt_name ||
        (typeof formData.pt_name === "string" && formData.pt_name.trim() === ""))
    ) {
      newErrors.pt_name = "Portuguese Name is required.";
    }

    if (
      formData.languages?.includes("korean") &&
      (!formData.kr_name ||
        (typeof formData.kr_name === "string" && formData.kr_name.trim() === ""))
    ) {
      newErrors.kr_name = "Korean Name is required.";
    }


    if (!formData.url || formData.url.trim() === "")
      newErrors.url = "URL is required.";
    if (!formData.category) {
      newErrors.category = "Category is required.";
    }
    if (!formData.currency)
      newErrors.currency = "Currency selection is required.";
    if (!formData.description || formData.description.trim() === "")
      newErrors.description = "Description is required.";
    if (!formData.factsheet_type)
      newErrors.factsheet_type = "Factsheet Type is required.";
    if (!formData.calculator_type)
      newErrors.calculator_type = "Calculator Type is required.";
    if (!formData.constituent_type || formData.constituent_type.trim() === "")
      newErrors.constituent_type = "Constituents field is required.";
    if (!formData.languages)
      newErrors.languages = "Language selection is required.";
    if (
      formData?.return_type?.includes("PR") &&
      !indexVersions["PR"]?.index_code
    )
      newErrors.pr_code = "PR Ticker is required.";
    if (
      formData?.return_type?.includes("TR") &&
      !indexVersions["TR"]?.index_code
    )
      newErrors.tr_code = "TR Ticker is required.";
    if (
      formData?.return_type?.includes("NTR") &&
      !indexVersions["NTR"]?.index_code
    )
      newErrors.ntr_code = "NTR Ticker is required.";
    if (!formData?.return_type)
      newErrors.return_type = "Return type is required.";
    if (formData.factsheet_type === "static" && !imageLink?.media_url) {
      newErrors.factsheet =
        "Factsheet file is required for Static Factsheet Type.";
    }
    if (formData?.languages?.includes("portuguese") && !formData?.pt_description) {
      newErrors.pt_description = "Portuguese Description is required.";
    }
    if (formData?.languages?.includes("korean") && !formData?.kr_description) {
      newErrors.kr_description = "Korean Description is required.";
    }
    if (formData?.languages?.includes("hebrew") && !formData?.hb_description) {
      newErrors.hb_description = "Hebrew Description is required.";
    }
    if (formData?.languages?.includes("japanese") && !formData?.jp_description) {
      newErrors.jp_description = "Japanese Description is required.";
    }

    console.log(newErrors, "newErrors");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    if (!validateForm()) {
      return;
    }

    let payload = {};
    const filteredLinearKeys = getLinearKeys(formData);
    for (let key of filteredLinearKeys) {
      payload[key] = formData[key] || "";
    }

    for (let key of LinearBooleanKeys) {
      payload[key] = formData[key] ? true : false;
    }
    for (let key of LineearKeysWithOptions) {
      payload[key] = formData[key] || null;
    }
    for (let key of KeysWithDate) {
      payload[key] = formData[key] || new Date().toISOString();
    }

    payload["page_title"] = formData.name || "";
    payload["canonical_url"] = formData.url || "";

    payload["methodology_media_url"] = selectedFile?.file_url
      ? selectedFile?.file_url
      : null;

    payload["factsheet_media_url"] = imageLink?.media_url
      ? imageLink?.media_url
      : null;

    let versions = [];
    for (let key of formData?.return_type) {
      versions.push({
        ...indexVersions[key],
        return_type: key,
        base_date: indexVersions[key]?.base_date || formData.base_date,
      });
    }

    payload["is_constituent_visible"] = payload["constituent_type"] == "No Constituents" ? false : true;

    if (payload["constituents_keys_visible"].includes("name")) {
      let newdata = payload["constituents_keys_visible"].filter(x => x !== "name");
      newdata.push("constituent_name");
      payload["constituents_keys_visible"] = newdata;
    }

    console.log(payload)

    try {
      setLoader(true);
      const res = await callApi(`v1/index/new-index`, "post", {
        index: payload,
        versions: versions,
      });
      setLoader(false);
      if (res.status === "Success") {
        showNotification("Index Created successfully", "success");
        setLoader(true);
        setTimeout(() => {
          navigate(INDEX_LIST_ROUTE);
          setLoader(false);
        }, 500);
      }
    } catch (e) {
      console.error("API Error:", e);
      showNotification(e.data?.data.message, "error");
      setLoader(false);
    }
  };

  const handleUpdate = (data, key) => {
    console.log(data, "data");
    let update = {
      ...formData,
      [key]: data?.file_url,
    };
    if (key === "methodology_media_url") {
      update.methodology_media_id = data?._id;
    } else if (key === "portuguese_media_url") {
      update.portuguese_media_id = data?._id;
    }
    else if (key === "korean_media_url") {
      update.korean_media_id = data?._id;
    }
    else if (key === "hebrew_media_url") {
      update.hebrew_media_id = data?._id;
    }
    else if (key === "japanese_media_url") {
      update.japanese_media_id = data?._id;
    }
    setFormData(update);
  };

  const handleDummy = () => { };

  const Constituentsupdate = [
    { label: "No Change", value: "nochange" },
    { label: "Daily", value: "daily" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" }
  ];

  return (
    <>
      <React.Fragment>
        <BreadCrumb
          title={INDEX_ADD_ROUTE}
          pageTitle={INDEX_LIST_ROUTE}
          version="v1"
        />
        <ToastContainer closeButton={false} limit={1} />
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div className="card-body">
              <div className="flex items-center justify-between">
                <h4 className="text-15">Manage Indices</h4>
                <div className="flex space-x-3">
                  <button
                    type="button"
                    className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
                    onClick={() => downloadConstituentSample()}
                  >
                    ⬇️ <span>Constituent Sample File</span>
                  </button>

                  <button
                    type="button"
                    className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
                    onClick={() => downloadValueSample()}
                  >
                    ⬇️ <span>Index Value Sample File</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form className="grid grid-cols-3 mx-auto gap-x-12 gap-y-6 max-w-7xl">
                <div>
                  <CustomDateInput
                    value={formData.base_date}
                    dateOptions={{ dateFormat: "Y-m-d" }}
                    isRequired={true}
                    keyName="base_date"
                    label="Base Date"
                    setDate={(selectedDates) => {
                      setErrors((prev) => ({ ...prev, ["base_date"]: "" }));
                      setFormData((prev) => ({
                        ...prev,
                        base_date: selectedDates[0]
                          ? selectedDates[0].toISOString()
                          : "",
                      }));
                    }}
                    placeholder="Select Date"
                    errors={errors}
                  />
                </div>



                <CustomInput
                  label="Url"
                  name="url"
                  type="text"
                  value={formData.url}
                  onChange={handleInputChange}
                  error={errors.url}
                  required
                  placeholder="Enter Url"
                />

                <div className="col-span-1">
                  <CustomSelect
                    label="Category"
                    name="category"
                    value={categoryOption || formData.category}
                    onChange={(selectedValue) =>
                      handleSelectChange("category", selectedValue)
                    }
                    isSearchable={true}
                    options={categoryList}
                    error={errors.category}
                    required
                  />
                  {categoryOption === "other" ? (
                    <CustomInput
                      label="Other"
                      name="category"
                      type="text"
                      value={formData.category}
                      onChange={handleInputChange}
                      error={""}
                      required={false}
                      placeholder="Enter other category"
                    />
                  ) : null}
                </div>

                <div className="col-span-1">
                  <CustomSelect
                    label="Sub Category"
                    name="sub_category"
                    value={subCategoryOption || formData.sub_category}
                    onChange={(selectedValue) =>
                      handleSelectChange("sub_category", selectedValue)
                    }
                    options={subCategoryList}
                    isSearchable={true}
                    error={""}
                  />
                  {subCategoryOption === "other" ? (
                    <CustomInput
                      label="Other"
                      name="sub_category"
                      type="text"
                      value={formData.sub_category}
                      onChange={handleInputChange}
                      error={""}
                      required={false}
                      placeholder="Enter other sub category"
                    />
                  ) : null}
                </div>

                <CustomSelect
                  label="Currency"
                  name="currency"
                  value={formData.currency}
                  onChange={(selectedValue) =>
                    handleSelectChange("currency", selectedValue)
                  }
                  options={IndexCurrency}
                  error={errors.currency}
                  required
                  isSearchable={true}
                />

                <div className="col-span-1">
                  <CustomSelect
                    label="Constituents Update"
                    name="constituents_update"
                    value={formData.constituents_update}
                    onChange={(selectedValue) => {
                      setFormData(prev => ({ ...prev, constituents_update: selectedValue }));
                      setErrors(prev => ({ ...prev, constituents_update: '' }));
                    }}
                    options={Constituentsupdate}
                    error={errors.constituents_update}
                    required
                    isSearchable={false}
                  />
                </div>

                <div className="col-span-2">
                  <CustomInput
                    label="Name"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleInputChange}
                    error={errors.name}
                    required
                    placeholder="Enter Name"
                  />
                </div>

                <div className="col-span-1">
                  <CustomInput
                    label="English Constituents Tagline"
                    name="constituents_tagline"
                    type="text"
                    value={formData.constituents_tagline}
                    onChange={handleInputChange}
                    error={errors.constituents_tagline}
                    // required
                    placeholder="Enter Constituents Tagline"
                  />
                </div>

                {formData?.languages?.includes("portuguese") && (
                  <>
                    <div className="col-span-2">
                      <CustomInput
                        label="Portuguese Name"
                        name="pt_name"
                        type="text"
                        value={formData.pt_name}
                        onChange={handleInputChange}
                        error={errors.pt_name}
                        required
                        placeholder="Enter Portuguese Name"
                      />
                    </div>

                    <div className="col-span-1">
                      <CustomInput
                        label="Portuguese Constituents Tagline"
                        name="pt_constituents_tagline"
                        type="text"
                        value={formData.pt_constituents_tagline}
                        onChange={handleInputChange}
                        error={errors.pt_constituents_tagline}
                        // required
                        placeholder="Enter Portuguese Constituents Tagline"
                      />
                    </div>
                  </>

                )}

                {formData?.languages?.includes("korean") && (
                  <>
                  
                  <div className="col-span-2">
                    <CustomInput
                      label="korean Name"
                      name="kr_name"
                      type="text"
                      value={formData.kr_name}
                      onChange={handleInputChange}
                      error={errors.kr_name}
                      required
                      placeholder="Enter korean Name"
                    />
                  </div>

                  <div className="col-span-1">
                      <CustomInput
                        label="Korean Constituents Tagline"
                        name="kr_constituents_tagline"
                        type="text"
                        value={formData.kr_constituents_tagline}
                        onChange={handleInputChange}
                        error={errors.kr_constituents_tagline}
                        // required
                        placeholder="Enter Korean Constituents Tagline"
                      />
                    </div>

                  </>
                )}

                {formData?.languages?.includes("hebrew") && (
                  <>
                  <div className="col-span-2">
                    <CustomInput
                      label="Hebrew Name"
                      name="hb_name"
                      type="text"
                      value={formData.hb_name}
                      onChange={handleInputChange}
                      error={errors.hb_name}
                      required
                      placeholder="Enter Hebrew Name"
                    />
                  </div>

                   <div className="col-span-1">
                      <CustomInput
                        label="Hebrew Constituents Tagline"
                        name="hb_constituents_tagline"
                        type="text"
                        value={formData.hb_constituents_tagline}
                        onChange={handleInputChange}
                        error={errors.hb_constituents_tagline}
                        // required
                        placeholder="Enter Hebrew Constituents Tagline"
                      />
                    </div>

                  </>
                )}

                {formData?.languages?.includes("japanese") && (
                  <>
                  <div className="col-span-2">
                    <CustomInput
                      label="Japanese Name"
                      name="jp_name"
                      type="text"
                      value={formData.jp_name}
                      onChange={handleInputChange}
                      error={errors.jp_name}
                      required
                      placeholder="Enter Japanese Name"
                    />
                  </div>

                   <div className="col-span-1">
                      <CustomInput
                        label="Japnese Constituents Tagline"
                        name="jp_constituents_tagline"
                        type="text"
                        value={formData.jp_constituents_tagline}
                        onChange={handleInputChange}
                        error={errors.jp_constituents_tagline}
                        // required
                        placeholder="Enter Japnese Constituents Tagline"
                      />
                    </div>

                  </>
                )}

                <div className="col-span-2">
                  <CustomTextArea
                    label="Description"
                    name="description"
                    value={formData.description}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        description: value,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        description: "",
                      }));
                    }}
                    error={errors.description}
                    required
                  />
                </div>

                {formData?.languages?.includes("portuguese") && (
                  <div className="col-span-2">
                    <CustomTextArea
                      label="Portuguese Description"
                      name="pt_description"
                      value={formData.pt_description}
                      onChange={(value) => {
                        setFormData((prev) => ({
                          ...prev,
                          pt_description: value,
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          pt_description: "",
                        }));
                      }}
                      error={errors.pt_description}
                      required
                    />
                  </div>
                )}

                {formData?.languages?.includes("korean") && (
                  <div className="col-span-2">
                    <CustomTextArea
                      label="Korean Description"
                      name="kr_description"
                      value={formData.kr_description}
                      onChange={(value) => {
                        setFormData((prev) => ({
                          ...prev,
                          kr_description: value,
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          kr_description: "",
                        }));
                      }}
                      error={errors.kr_description}
                      required
                    />
                  </div>
                )}

                {formData?.languages?.includes("hebrew") && (
                  <div className="col-span-2">
                    <CustomTextArea
                      label="Hebrew Description"
                      name="hb_description"
                      value={formData.hb_description}
                      onChange={(value) => {
                        setFormData((prev) => ({
                          ...prev,
                          hb_description: value,
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          hb_description: "",
                        }));
                      }}
                      error={errors.hb_description}
                      required
                    />
                  </div>
                )}

                {formData?.languages?.includes("japanese") && (
                  <div className="col-span-2">
                    <CustomTextArea
                      label="Japanese Description"
                      name="jp_description"
                      value={formData.jp_description}
                      onChange={(value) => {
                        setFormData((prev) => ({
                          ...prev,
                          jp_description: value,
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          jp_description: "",
                        }));
                      }}
                      error={errors.jp_description}
                      required
                    />
                  </div>
                )}

                <div className="col-span-1"></div>

                <CustomSelect
                  label="Factsheet Type"
                  name="factsheet_type"
                  value={formData.factsheet_type}
                  onChange={(selectedValue) =>
                    handleSelectChange("factsheet_type", selectedValue)
                  }
                  options={factsheetTypeList}
                  error={errors.factsheet_type}
                  required
                />

                {formData?.factsheet_type === "static" &&
                  (imageLink ? (
                    <div className="col-span-1">
                      <label className="block mb-1 font-medium">
                        {"Factsheet"}
                      </label>

                      <div className="flex gap-2 ">
                        <div
                          onClick={() => {
                            setImageData(undefined);
                            toggleImage();
                          }}
                          className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
                        >
                          📂 Change Factsheet
                        </div>
                        {imageLink?.file_name ? (
                          <div
                            onClick={() => {
                              let document = imageLink?.media_url;
                              setDocumentView({
                                document,
                                file_name: imageLink?.file_name
                                  ? imageLink?.file_name
                                  : null,
                              });
                              setShowMode(true);
                              setDocView(undefined);
                            }}
                            className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
                          >
                            View
                          </div>
                        ) : null}
                      </div>
                      <div className="w-4/5 mt-2">
                        {imageLink?.file_name ? imageLink?.file_name : null}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="col-span-1">
                        <label className="block mb-1 font-medium">
                          {"Factsheet"}
                        </label>
                        <div
                          onClick={() => {
                            setImageData(undefined);
                            toggleImage();
                          }}
                          className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
                        >
                          {"⬆️ Add Factsheet"}
                        </div>
                        <p className="text-[red]">{errors?.factsheet}</p>
                      </div>
                    </>
                  ))}

                <CustomSelect
                  label="Return Type"
                  name="return_type"
                  value={formData.return_type}
                  onChange={(selectedValues) =>
                    handleMultiSelectChange(
                      "return_type",
                      selectedValues as string[]
                    )
                  }
                  options={returnTypeList}
                  error={errors.return_type}
                  required
                  isMulti
                />

                {formData?.factsheet_type !== "static" && (
                  <div className="col-span-1"></div>
                )}

                {selectedValues &&
                  selectedValues?.map((item) => (
                    <div className="col-span-3" key={item}>
                      <div className="grid grid-cols-4 gap-x-4">
                        <div className="col-span-1">
                          <CustomInput
                            label="Return Type"
                            name=""
                            type="text"
                            value={item}
                            onChange={handleDummy}
                            error={""}
                            placeholder=""
                            required
                            disabled
                          />
                        </div>
                        <div className="col-span-1">
                          <CustomInput
                            label="Ticker"
                            name="index_code"
                            type="text"
                            value={indexVersions[item].index_code}
                            onChange={(e) => handleVersionChange(item, e)}
                            error={item?.includes("PR") ? errors.pr_code : ""}
                            placeholder="Enter Ticker Code"
                            required
                          />
                        </div>
                        <div className="col-span-1">
                          <label className="block mb-1 font-medium">
                            {"Benchmark"}
                          </label>
                          <SearchDropdown
                            value={indexVersions[item].benchmark_code}
                            input={item}
                            handleBenchmarkChange={(name, value) =>
                              handleBenchmarkChange(item, name, value)
                            }
                            name={"benchmark_code"}
                            category={"Benchmark Indices"}
                          />
                        </div>
                        <div className="col-span-1">
                          <CustomDateInput
                            value={indexVersions[item]?.base_date}
                            dateOptions={{ dateFormat: "Y-m-d" }}
                            isRequired={false}
                            keyName={`base_date_${item}`}
                            label={`${item} Base Date`}
                            setDate={(selectedDates) => {
                              setIndexVersions((prev) => ({
                                ...prev,
                                [item]: {
                                  ...prev[item],
                                  base_date: selectedDates && selectedDates[0]
                                    ? selectedDates[0]?.toISOString()
                                    : new Date().toISOString(),
                                },
                              }));
                            }}
                            placeholder="Select Date"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                <div className="grid grid-cols-5 col-span-3 gap-2">
                  {checkTypeIndex.map((key) => (
                    <label
                      key={key.label}
                      className="flex items-center space-x-2"
                    >
                      <input
                        type="checkbox"
                        name={key.value}
                        checked={checkedType.some((item) => item === key.value)}
                        onChange={handleFormData}
                      />
                      <span className="capitalize">
                        {key.label.replace(/([A-Z])/g, " $1")}
                      </span>
                    </label>
                  ))}
                </div>

                <CustomSelect
                  label="Constituents"
                  name="constituent_type"
                  value={formData.constituent_type}
                  onChange={(selectedValue) =>
                    handleSelectChange("constituent_type", selectedValue)
                  }
                  options={constituentTypeList}
                  error={errors.constituent_type}
                  required
                />

                <CustomSelect
                  label="Language"
                  name="languages"
                  value={formData.languages}
                  onChange={(selectedValue) =>
                    handleSelectChange("languages", selectedValue as string[])
                  }
                  options={languageList}
                  error={errors.languages}
                  required
                  isMulti
                />

                <CustomSelect
                  label="Calculator Type"
                  name="calculator_type"
                  value={formData.calculator_type}
                  onChange={(selectedValue) =>
                    handleSelectChange("calculator_type", selectedValue)
                  }
                  options={[
                    { label: "ICAL", value: "ICAL" },
                    { label: "WLI", value: "WLI" },
                    { label: "Solactive", value: "Solactive" },
                    { label: "Refintive", value: "Refintive" },
                  ]}
                  error={errors.calculator_type}
                  required
                />

                {(formData?.constituent_type === "Only Top 5 Constituents" ||
                  formData?.constituent_type === "All Constituents") && (
                    <>
                      <div className="grid grid-cols-5 col-span-3 gap-2">
                        {constituentType.map((key) => (
                          <label
                            key={key.label}
                            className="flex items-center space-x-2"
                          >
                            <input
                              type="checkbox"
                              name={key.value}
                              checked={constituentData.some(
                                (item) => item === key.value
                              )}
                              onChange={handleConstituentData}
                            />
                            <span className="capitalize">
                              {key.label.replace(/([A-Z])/g, " $1")}
                            </span>
                          </label>
                        ))}
                      </div>
                    </>
                  )}

                {formData?.languages?.includes("english") && (
                  <MethodologyFileUploader
                    key="english"
                    buttonText="English"
                    handleUpdate={(data) =>
                      handleUpdate(data, "methodology_media_url")
                    }
                    language="english"
                    keyValue="methodology_media_url"
                    isDocument={isDocument}
                    formData={formData}
                    selectedFiles={selectedFiles}
                    setDocumentView={setDocumentView}
                  />
                )}

                {formData?.languages?.includes("portuguese") && (
                  <MethodologyFileUploader
                    key="portuguese"
                    buttonText="Portuguese"
                    handleUpdate={(data) =>
                      handleUpdate(data, "portuguese_media_url")
                    }
                    language="portuguese"
                    keyValue="portuguese_media_url"
                    isDocument={isDocument}
                    formData={formData}
                    selectedFiles={selectedFiles}
                    setDocumentView={setDocumentView}
                  />
                )}

                {formData?.languages?.includes("korean") && (
                  <MethodologyFileUploader
                    key="korean"
                    buttonText="Korean"
                    handleUpdate={(data) =>
                      handleUpdate(data, "korean_media_url")
                    }
                    language="korean"
                    keyValue="korean_media_url"
                    isDocument={isDocument}
                    formData={formData}
                    selectedFiles={selectedFiles}
                    setDocumentView={setDocumentView}
                  />
                )}

                {formData?.languages?.includes("hebrew") && (
                  <MethodologyFileUploader
                    key="hebrew"
                    buttonText="Hebrew "
                    handleUpdate={(data) =>
                      handleUpdate(data, "hebrew_media_url")
                    }
                    language="hebrew"
                    keyValue="hebrew_media_url"
                    isDocument={isDocument}
                    formData={formData}
                    selectedFiles={selectedFiles}
                    setDocumentView={setDocumentView}
                  />
                )}

                {formData?.languages?.includes("japanese") && (
                  <MethodologyFileUploader
                    key="japanese"
                    buttonText="Japanese"
                    handleUpdate={(data) =>
                      handleUpdate(data, "japanese_media_url")
                    }
                    language="japanese"
                    keyValue="japanese_media_url"
                    isDocument={isDocument}
                    formData={formData}
                    selectedFiles={selectedFiles}
                    setDocumentView={setDocumentView}
                  />
                )}

                {formData?.languages?.includes("english") &&
                  formData?.languages?.includes("portuguese") &&
                  formData?.languages?.includes("japanese") &&
                  formData?.languages?.includes("hebrew") &&
                  formData?.languages?.includes("korean") && (
                    <div className="col-span-1"></div>
                  )}

                <div className="flex justify-end col-span-3 mt-6 space-x-4">
                  <button
                    type="button"
                    className="px-4 py-2 text-white bg-gray-400 rounded-md hover:bg-gray-500"
                    onClick={() => {
                      setFormData(initialFormData);
                      setErrors({});
                      setCheckedType([]);
                      setConstituentData([]);
                      setLoader(false);
                    }}
                  >
                    Reset
                  </button>
                  <button
                    type="button"
                    disabled={loader}
                    style={{
                      minWidth: "120px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    className="px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700"
                    onClick={handleSubmit}
                  >
                    {loader ? <LoaderComponent /> : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <Drawer
          show={showImage}
          onHide={toggleImage}
          id="drawerEnd"
          drawer-end="true"
          className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
          <Drawer.Header
            className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
            closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </Drawer.Header>
          <Drawer.Body className="h-full p-4 overflow-y-auto">
            <ImageView
              showImage={showImage}
              setEventData={setImageData}
              togleImage={toggleImage}
            />
          </Drawer.Body>
        </Drawer>

        <Drawer
          show={showMode}
          onHide={defaultToggle}
          id="drawerEnd"
          drawer-end="true"
          className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
          <Drawer.Header
            className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
            closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <Drawer.Title className="text-15">
              {documentView?.file_name
                ? documentView?.file_name
                : "Document View"}
            </Drawer.Title>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </Drawer.Header>
          <Drawer.Body className="h-full p-4 overflow-y-auto">
            <iframe
              src={
                docView === undefined
                  ? getImageUrl(
                    documentView?.document ? documentView?.document : null
                  )
                  : documentView?.document
                    ? documentView?.document
                    : null
              }
              className="w-[80vh] h-[80vh] rounded-md"
            />
          </Drawer.Body>
        </Drawer>
      </React.Fragment>
    </>
  );
};

export default ManageIndices;